export default "__VITE_ASSET__2f0c791c__"